<template>
  <div class="header-box">
    <div class="header">
      <button class="menu-button" @click="toggleMenuDisplay"><van-icon name="ellipsis" /></button>
      <h1 class="page-title">{{ title }}</h1>
      <div class="right-space"><slot name="right-space"></slot></div>
    </div>
    <van-popup class="popup-menu" v-model="showMenu" position="left">
      <van-sidebar class="menu-list" v-model="activeMenu" @change="handleNaviItemSelected">
        <van-sidebar-item v-for="(item, index) in menuList" :key="index" :title="item.title" />
      </van-sidebar>
      <van-button class="logout" type="default" @click="logout">退出登录</van-button>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',

  props: {
    title: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showMenu: false,
      activeMenu: 0,

      menuList: [
        {
          index: 0,
          title: '总览',
          path: '/'
        },
        {
          index: 1,
          title: '用户管理',
          path: '/users'
        },
        {
          index: 2,
          title: '会员管理',
          path: '/members'
        },
        {
          index: 3,
          title: '签到管理',
          path: '/check-in-records'
        },
        {
          index: 4,
          title: '商品分类',
          path: '/categories'
        },
        {
          index: 5,
          title: '商品管理',
          path: '/spus'
        },
        {
          index: 6,
          title: '发货单',
          path: '/delivery-notes'
        },
        {
          index: 7,
          title: '每日一题',
          path: '/prize-quizzes'
        },
        {
          index: 8,
          title: '帖子',
          path: '/posts'
        },
        {
          index: 9,
          title: '轮播图',
          path: '/sliders'
        },
        {
          index: 10,
          title: '通知',
          path: '/notices'
        },
        {
          index: 11,
          title: '积分账户',
          path: '/reward-points-accounts'
        },
        {
          index: 12,
          title: '系统设置',
          path: '/settings'
        }
      ]
    }
  },

  watch: {
    $route() {
      this.initMenu()
    }
  },

  methods: {
    toggleMenuDisplay() {
      this.showMenu = !this.showMenu
    },

    handleNaviItemSelected(index) {
      const menuItem = this.menuList.find((item) => item.index === index)
      this.$router.push(menuItem.path)
      this.showMenu = false
    },

    /**
     * 根据当前路由解析用于匹配侧栏菜单的路径（支持子页通过 meta.activeMenuPath 归属到父级菜单）
     */
    getMenuPathForRoute() {
      const { activeMenuPath } = this.$route.meta || {}
      return activeMenuPath || this.$route.path
    },

    /**
     * 将侧栏高亮项与当前路由（或 meta 指定的归属菜单）对齐
     */
    initMenu() {
      const pathForMenu = this.getMenuPathForRoute()
      const menuItem = this.menuList.find((item) => item.path === pathForMenu)
      this.activeMenu = menuItem ? menuItem.index : 0
    },

    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    }
  },

  mounted() {
    this.initMenu()
  }
}
</script>
<style lang="scss" scoped>
.header-box {
  .header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 20px;

    .menu-button {
      flex-shrink: 0;
      margin: 0;
      padding: 0;
      margin-right: 10px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      // border: .5px solid #666;
      // border-radius: 4px;
    }

    .page-title {
      flex-shrink: 0;
      font-size: 20px;
    }

    .right-space {
      flex-grow: 1;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .popup-menu {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 30%;
    height: 100vh;

    .menu-list {
      flex-grow: 1;
      width: 100%;

      .van-sidebar-item--select::before {
        background-color: #1989fa;
      }
    }

    .logout {
      margin-bottom: 30px;
    }
  }
}
</style>
